var Mdg2Response = (function () {
    function Mdg2Response(msg) {
        this.raw = msg;
    }
    Object.defineProperty(Mdg2Response.prototype, "name", {
        get: function () {
            return this.raw.Message;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mdg2Response.prototype, "jobId", {
        get: function () {
            return this.raw.header.id_job;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mdg2Response.prototype, "serviceId", {
        get: function () {
            return this.raw.header.id_service;
        },
        enumerable: false,
        configurable: true
    });
    Mdg2Response.prototype.isUpdateMessage = function () {
        return this.raw.hasOwnProperty('header') &&
            (this.raw.header.hasOwnProperty('id_service') || this.raw.header.hasOwnProperty('id_job')) &&
            this.raw.Message.endsWith('Update');
    };
    Mdg2Response.prototype.isLossMessage = function () {
        return this.raw.hasOwnProperty('header') && this.raw.header.hasOwnProperty('id_service') &&
            this.raw.Message.endsWith('Loss');
    };
    return Mdg2Response;
}());
export { Mdg2Response };
//# sourceMappingURL=Mdg2Response.js.map